<div [ngClass]="{
  hovered: isHovered,
  'pointer-events-none': !hasAction()
}" class="notification-container">
  @if (!isOtherType) {
    <a
      [queryParams]="urlParams"
      [routerLink]="[urlBase]"
      (click)="handleClick($event)"
      class="notification-check-details"
      title="Check details"
    >
      <span class="notification-title typography-paragraph font-bold">{{ notification.Title | truncate: 40 }}</span>
      <span class="notification-headline typography-paragraph">{{ notification.Headline | truncate: 70 : true }}</span>
      <span class="notification-post-date">
        <span title="{{ notification.PostDate | amTimeAgo }}">{{ notification.PostDate | amTimeAgo }}</span>
        @if (notification.Reason && notification.Reason != 'Published' && !hideReason()) {
          <span>- {{ notification.Reason }}</span>
        }
      </span>
    </a>
  }

  @if (isOtherType) {
    <a
      [attr.href]="notification.Payload"
      (click)="handleClick($event)"
      class="notification-check-details"
      target="_blank"
      title="Check details"
    >
      <span class="notification-title typography-paragraph font-bold">
        {{ notification.Title | truncate: 40 : true }}
      </span>
      <span class="notification-headline typography-paragraph">{{ notification.Headline | truncate: 70 }}</span>
      <span class="notification-post-date">
        <span title="{{ notification.PostDate | amTimeAgo }}">{{ notification.PostDate | amTimeAgo }}</span>
      </span>
    </a>
  }
</div>
